<template>
  <div class="user-manage-box vice-president" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <p class="label">系统：</p>
              <el-select
                v-model="filter.sys"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option
                  v-for="item in system"
                  :key="item.value"
                  :label="item.labelName"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <div class="label">用户ID：</div>
              <el-input
                class="input"
                v-model="filter.uid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <div class="label">手机号：</div>
              <el-input
                class="input"
                v-model="filter.phone"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <div class="btn-box">
            <!-- <button class="search" @click="order2excel">导出</button> -->
            <button class="search" @click="authorizationModal">
              开通副总裁
            </button>
          </div>
        </div>
        <el-table
          :data="userList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="sys" align="center" label="系统">
            <div slot-scope="scope">
              {{ systemMap[scope.row.sys] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="uid"
            align="center"
            label="用户ID"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            align="center"
            label="用户昵称"
          ></el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            label="手机号"
          ></el-table-column>
          <el-table-column prop="role" align="center" label="会员身份">
            <div slot-scope="scope">
              {{ roleMap[scope.row.roleTypeOne] || "-" }}
            </div>
          </el-table-column>
          <el-table-column prop="sumRole" align="center" label="当前身份">
            <div slot-scope="scope">
              {{ roleMap[scope.row.roleTypeThree] || "-" }}
            </div>
          </el-table-column>
          <el-table-column prop="spuName" align="center" label="关联商品">
          </el-table-column>
          <!-- <el-table-column prop="role" align="center" label="团队身份">
              <div slot-scope="scope">
                {{ levelMap[scope.row.teamRole] || '-' }}
              </div>
            </el-table-column> -->
          <!-- <el-table-column
              prop="earning"
              align="center"
              label="总收益/元"
            ></el-table-column> -->
          <el-table-column prop="created" align="center" label="开通时间">
            <div slot-scope="scope">
              {{ scope.row.openTime | dateFormat }}
            </div>
          </el-table-column>
          <el-table-column prop="operatorId" align="center" label="操作人ID">
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <div
              slot-scope="scope"
              style="display: flex; justify-content: center"
            >
              <div style="display: flex; justify-content: center">
                <button
                  size="mini"
                  class="table-btn"
                  @click="updateStatus(scope.row.uid)"
                >
                  关闭
                </button>
              </div>
              <div style="display: flex; justify-content: center">
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleSettingModal(scope.row)"
                >
                  设置
                </button>
              </div>
              <!-- <div
                style="display: flex; justify-content: center"
                v-if="scope.row.status === 1"
              >
                <button
                  size="mini"
                  class="table-btn"
                  @click="updateStatus(scope.row.uid, 0)"
                >
                  开启
                </button>
              </div> -->
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer" :key="paginationKey">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="authorizationShow"
      @close="selectGoodsVisible = false"
      class="dialog"
      width="618px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">开通副总裁</div>
      <el-form
        ref="form"
        :model="authorizationForm"
        class="authorization-form"
        label-width="auto"
      >
        <el-form-item label="用户ID" prop="uid" class="form-item">
          <input
            placeholder="输入用户ID"
            class="input"
            v-model.number="authorizationForm.uid"
            type="number"
            style="width: 185px;box-sizing: border-box;"
            placeholder-class="placeholder"
            onKeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
          />
        </el-form-item>
        <el-form-item label="关联商品" prop="role" class="form-item">
          <el-popover
            placement="bottom"
            width="900"
            trigger="manual"
            v-model="selectGoodsVisible"
          >
            <div class="select-goods">
              <div class="filter-box">
                <div class="filter">
                  <div class="filter-item" style="margin-right: 15px;">
                    <div class="label">商品分区：</div>
                    <el-select
                      v-model="goodsFilter.partition"
                      size="small"
                      class="select"
                      style="width: 116px"
                      placeholder="请选择"
                    >
                      <el-option :value="null" label="全部"> </el-option>
                      <el-option
                        :value="item"
                        :label="item"
                        v-for="item in partitionList"
                        :key="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="filter-item" style="margin-right: 15px;">
                    <div class="label">商品分类：</div>
                    <el-cascader
                      v-model="category"
                      :options="categoryList"
                      placeholder="请选择"
                      size="small"
                      :props="{
                        children: 'second',
                        value: 'id',
                        label: 'name',
                        checkStrictly: true,
                      }"
                      class="good-input"
                      style="width: 116px"
                    ></el-cascader>
                  </div>
                  <div class="filter-item" style="margin-right: 15px;">
                    <div class="label">商品状态：</div>
                    <el-select
                      v-model="goodsFilter.status"
                      size="small"
                      class="select"
                      style="width: 116px"
                      placeholder="请选择"
                    >
                      <el-option :value="null" label="全部"> </el-option>
                      <el-option :value="3" label="出售中"> </el-option>
                      <el-option :value="1" label="仓库中"> </el-option>
                    </el-select>
                  </div>
                  <div class="filter-item" style="margin-right: 12px;">
                    <div class="label">商品名称：</div>
                    <el-input
                      class="input"
                      v-model="goodsFilter.name"
                      style="width: 116px;"
                      placeholder="商品名称"
                      size="small"
                    ></el-input>
                  </div>
                  <div class="btn-box" style="margin: 0;">
                    <button class="search" @click="searchGoods">筛选</button>
                  </div>
                </div>
              </div>
              <el-table
                :data="goodsList"
                class="order-table table no-border-table"
                ref="singleTable"
                max-height="300"
                :header-cell-style="{
                  border: 'none',
                  color: '#333',
                  background: '#f6f6f6',
                  borderBottom: '1px solid #E8E8E8',
                  height: '44px',
                }"
                :row-style="{
                  height: '44px',
                }"
                @selection-change="handleSelectionChange"
                highlight-selection-row
                tooltip-effect="dark"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column
                  prop="name"
                  align="center"
                  label="商品名称"
                  width="240"
                ></el-table-column>
                <el-table-column
                  prop="minPrice"
                  align="center"
                  label="价格"
                ></el-table-column>
                <el-table-column prop="phone" align="center" label="商品分类">
                  <div slot-scope="scope">
                    {{
                      scope.row.firstSortName + "/" + scope.row.secondSortName
                    }}
                  </div>
                </el-table-column>
                <el-table-column
                  prop="partition"
                  align="center"
                  label="商品分区"
                ></el-table-column>
                <el-table-column prop="status" align="center" label="状态">
                  <div slot-scope="scope">
                    {{ scope.row.status === 3 ? "出售中" : "仓库中" }}
                  </div>
                </el-table-column>
                <el-table-column
                  prop="totalStock"
                  align="center"
                  label="库存"
                ></el-table-column>
              </el-table>
              <div class="btn-box">
                <div class="reset" @click="selectGoodsVisible = false">
                  取消
                </div>
                <div class="search" @click="selectGoods">确定</div>
              </div>
            </div>
            <div slot="reference" @click="selectGoodsModal">
              <el-input style="width: 185px;" readonly size="small" v-model="goodInfo.name" placeholder="请选择商品"></el-input>
            </div>
            <!-- <el-button slot="reference">click 激活</el-button> -->
          </el-popover>
          <!-- <el-select
            v-model="authorizationForm.spuId"
            class="select"
            placeholder="请选择"
            size="small"
            style="width: 185px"
          >
            <el-option
              v-for="item in goodsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="authorizationShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleAuthorization"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visible" class="dialog" width="618px" top="25vh">
      <div slot="title" class="dialog-title">设置</div>
      <el-form
        ref="form"
        :model="settingForm"
        class="authorization-form"
        label-width="auto"
      >
        <el-form-item label="关联商品" prop="role" class="form-item">
          {{ spuName }}
        </el-form-item>
        <el-form-item label="商品利润" prop="uid" class="form-item">
          <input
            placeholder="请输入数值"
            class="input"
            v-model.number="settingForm.amount"
            type="number"
            placeholder-class="placeholder"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleSetting"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
import dayjs from 'dayjs';
export default {
  components: {
    Header
  },
  name: 'user-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '副总裁管理'
      },
      filter: {
        // 过滤条件
        sys: 0,
        phone: '',
        uid: null,
      },
      userList: [], // 用户列表
      date: [],
      currentSort: null,
      uid: null,
      phone: '',
      paginationKey: +new Date(),
      showProgressDialog: false,
      progress: 0,
      authorizationForm: {
        uid: null,
        spuId: null
      },
      authorizationShow: false,
      role: [],
      system: [],
      roleMap: {},
      systemMap: {},
      visible: false,
      settingForm: {
        amount: null
      },
      goodsList: [],
      spuName: '',
      partitionList: [
        '主推区',
        '优选区',
        '福利区',
        '直播区'
      ],
      categoryList: [],
      category: [],
      goodsFilter: {
        name: '',
        status: null,
        partition: ''
      },
      selectGoodsVisible: false,
      multipleSelection: [],
      goodInfo: {}
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.name !== 'userDetail' && from.name !== 'popularize') {
  //     sessionStorage.setItem('userManage', '');
  //   }
  //   next();
  // },
  mounted() {
    // let data = sessionStorage.getItem('userManage')
    //   ? JSON.parse(sessionStorage.getItem('userManage'))
    //   : '';
    // if (data) {
    //   this.filter = {
    //     ...this.filter,
    //     ...data.filter
    //   };
    //   this.date = data.date;
    //   this.currentPage = data.currentPage;
    //   this.paginationKey = +new Date();
    //   this.setSearchData();
    // }
    // 获取列表
    this.getUserList();
    this.getDictionary();
    // this.getGoodsList();
    this.getCategoryList();
  },
  computed: {},
  methods: {
    setSearchData() {
      // let userManage = {
      //   currentPage: this.currentPage,
      //   filter: this.filter,
      //   date: this.date
      // };
      // sessionStorage.setItem('userManage', JSON.stringify(userManage));
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getUserList();
    },
    // 获取用户列表
    getUserList() {
      this.filter.start = this.date[0] || '';
      this.filter.end = this.date[1] || '';
      // console.log(this.filter);
      this.setSearchData();
      // return;
      this.loading++;
      this.httpGet(this.$root.getVicePresidentList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.userList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 获取分类列表
    getCategoryList() {
      this.loading++;
      this.httpGet(this.$root.getGoodsCategoryList, {}).then(
        (res) => {
          this.loading--;
          this.categoryList = res.list.filter((item) => item.second.length);
          this.categoryList.unshift({
            name: '全部',
            id: 0
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionary(){
      this.getDictionaryByName('role');
      this.getDictionaryByName('system');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getGoodsList() {
      this.setSearchData();
      this.loading++;
      this.httpGet(this.$root.getGoodsList, {
        page: 1,
        size: 9999,
      }).then(
        (res) => {
          this.loading--;
          this.goodsList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    searchGoods(){
      this.loading++;
      this.httpGet(this.$root.getGoodsList, {
        page: 1,
        size: 9999,
        ...this.goodsFilter,
        firstSortId: this.category[0] || 0,
        secondSortId: this.category[1] || 0
      }).then(
        (res) => {
          this.loading--;
          this.goodsList = res.list;
          this.multipleSelection = [];
          // this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    selectGoodsModal(){
      // this.multipleSelection = [];
      // this.goodInfo = {};
      this.selectGoodsVisible = true;
    },
    selectGoods(){
      if(this.multipleSelection.length > 0){
        this.authorizationForm.spuId = this.multipleSelection[0].id;
        this.goodInfo = this.multipleSelection[0];
        this.selectGoodsVisible = false;
      } else {
        this.$message.error('请选择商品')
      }
    },
    handleSelectionChange(val) {
      // console.log(val);
      if (val.length > 1) {
        const del_row = val.shift();
        this.$refs.singleTable.toggleRowSelection(del_row, false);
      }
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    authorizationModal() {
      this.userDetail = {};
      this.authorizationForm = {
        uid: null,
        spuId: null
      };
      this.goodInfo = {};
      this.multipleSelection = [];
      this.goodsList = [];
      this.goodsFilter = {
        name: '',
        status: null,
        partition: ''
      };
      this.category = [];
      this.$refs.form && this.$refs.form.clearValidate();
      this.authorizationShow = true;
    },
    // 身份授权
    handleAuthorization() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          this.httpPut(this.$root.openAgent, {
            ...this.authorizationForm,
            newRole: 5
          }).then(
            (res) => {
              this.loading--;
              this.authorizationShow = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getUserList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    handleSettingModal(rowdata){
      this.uid = rowdata.uid;
      this.spuName = rowdata.spuName;
      this.settingForm.amount = rowdata.amount || null;
      this.visible = true;
    },
    handleSetting(){
      this.loading++;
          this.httpPut(this.$root.getVicePresidentSet, {
            ...this.settingForm,
            uid: this.uid
          }).then(
            (res) => {
              this.loading--;
              this.visible = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getUserList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getUserList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        sys: 0,
        phone: '',
        uid: null,
      };
      this.date = [];
      this.getUserList();
    },
    updateStatus(uid) {
      // let str = '';
      // if (status === 1) {
      //   str = '封禁';
      // } else if (status === 0) {
      //   str = '开启';
      // }
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要关闭吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.closeRole, {
          uid,
          changeType: 3
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getUserList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    async order2excel() {
      this.loading++;
      let userList = [];
      let totalPage = null;
      let data = {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      };
      await this.httpGet(this.$root.getUserList, data).then(
        (res) => {
          this.loading--;
          totalPage = Math.ceil(parseInt(res.total) / this.size);
        },
        () => {
          this.loading--;
        }
      );
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(totalPage, userList).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(userList);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(totalPage, list) {
      for (let i = 1; i <= totalPage; i++) {
        let data = {
          page: i,
          size: this.size,
          ...this.filter
        };
        await this.httpGet(this.$root.getUserList, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / totalPage) * 100);
          console.log('page' + i, list.length);
        });
        // console.log(5555, list);
      }
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        let obj = {
          用户ID: item.uid,
          用户昵称: item.nickname,
          电话: item.phone,
          会员身份: item.sumRole,
          注册时间: item.created,
          可提现佣金: 0,
          业绩积分: 0,
          团队总业绩: 0,
          我的好友人数: item.friend,
          我的团队人数: item.head
        };
        formatList.push(obj);
      });
      myUtils.json2excel(formatList);
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
.select-goods >>>.el-table__header{
  .el-checkbox{
    display: none !important;
  }
}
.user-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 40px;
      }

      .select, .input {
        width: 128px;
      }

      .date-input {
        width: 225px;
      }

      .btn-box {
        margin: 0;
        .search{
          width: auto;
          min-width: 65px;
          padding: 0 12px;
        }
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }
  .authorization-form {
    padding: 16px 0 16px 120px;

    .input {
      width: 220px;
      height: 32px;
      line-height: 40px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 15px;
      color: gray9;

      &::placeholder {
        /* WebKit browsers */
        color: #ccc;
      }
    }

    .search-btn {
      display: inline-block;
      confirm-btn();
      width: 72px;
      height: 32px;
      line-height: 32px;
      margin: 0 12px;
    }
  }
}
.select-goods{
  .btn-box {
    flex-x(center);
    flex-wrap: nowrap;
    margin-top: 20px;

    .search {
      width: 65px;
      height: 32px;
      confirm-btn();
      flex-x(center);
      // margin-right: 8px;
    }

    .reset {
      width: 65px;
      height: 32px;
      cancel-btn();
      flex-x(center);
      margin-right: 10px;
    }
  }
}
</style>
